<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Edit User</h2>
  </div>
  <app-user-form
    [form]="form"
    [createdDate]="createdDate"
    [updatedDate]="updatedDate"
    submitButtonText="Update User"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-user-form>
</div>
